<div class="g__loader-container"><div class="g__loader" v-for="i in 4"></div></div>